<script>
  import { onMount, onDestroy } from 'svelte'
  import { push, replace } from 'svelte-spa-router'
  import { clientStore, userStore, peopleStore, locationStore } from '../../state/store'
  import { t, formatI18nDate, language } from '../../i18n/i18n'
  import { isUserAdmin, getName } from './../../helpers/utils.js'
  //Gets named parameters from Router
  export let params = {}

  import Spinner from '../../components/Spinner.svelte'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import ClientHeader from './Client.header.svelte'
  import { getLocationData, getPeopleData, getClientData } from '../../state/actions'
  import Breadcrumbs from '../../components/Breadcrumbs.svelte';

  // Location Id from url
  $: client = {
    locations: []
  }
  let address
  let unsub
  let promise
  onMount(() => {
    if (!isUserAdmin($userStore)) { replace('/') }
    promise = Promise.all([getPeopleData(), getClientData(), getPeopleData()])
    unsub = clientStore.subscribe(clients => {
      client = clients.find(cl => cl._id === params.id)
      if(client) {
        address = {
          phone_number: client.phone_number,
          email: client.email
        }
      }
    })
  })

  const navToLocation = (locationId) => {
    if($locationStore.length  === 0) {
      getLocationData()
    }
    push(`/locations/${locationId}`)
  }

  onDestroy(() => unsub())

</script>
{#await promise}
  <Spinner />
{:then}
  <ViewContainer>
    {#if client}
      <Breadcrumbs current={client.name}></Breadcrumbs>

    <section class="g-detail-page">
      <ClientHeader {client} {address} />

      <div>
        <h2>{$t['Clients Locations']}</h2>
        <article class="g-card-list-wrapper">
          {#if client.locations.length > 0}
            {#each client.locations as location, index}
              <ul class='g-card-list' on:click={() => navToLocation(location._id)}>
                {#each Object.entries(location) as [key, val]}
                  {#if 
                    key !== 'tenant' &&
                    key !== '_id' &&
                    key !== 'client' &&
                    key !== 'assignee' &&
                    key !== 'last_serviced' &&
                    key !== 'coordinates' &&
                    key !== '__v'
                  }
                    <li>
                      <p>{$t[key]}</p>
                      <p>{val}</p>
                    </li>
                  {/if}
                  {#if key === 'assignee'}
                    <li>
                      <p>{$t[key]}</p>
                      <p class:g-error={getName($peopleStore, val) === 'Unassigned'}>{getName($peopleStore, val)}</p>
                      </li>
                  {/if}
                  {#if key === 'last_serviced'}
                <li>
                  <p>{$t[key]}</p>
                  <p>{formatI18nDate($language, val)}</p>
                </li>
              {/if}
                {/each}
              </ul>
            {/each}
            {:else}
              <p>{$t['No Locations']}</p>
          {/if}
        </article>
      </div>
    </section>
    {/if}
  </ViewContainer>
{/await}